export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14916.4f7c781a.jpg";